import React from "react";

const PageTemplate = ({
  title,
  buttonLabel = null,
  onButtonClick = null,
  buttonClassName = "lumen-glow-button",
  headerRight = null,
  titleClassName = "",
  wrapperClassName = "",
  children,
}) => {
  const highlightLocalhostHeader = React.useMemo(() => {
    try {
      if (typeof window === "undefined") return false;
      const host = window.location?.hostname || "";
      return host === "localhost" || host === "127.0.0.1" || host === "::1";
    } catch {
      return false;
    }
  }, []);

  return (
    <div className="relative min-h-full w-full print:p-0">
      <div>
        <div className={`mx-auto w-full ${wrapperClassName}`}>
          {(title || (buttonLabel && onButtonClick)) && (
            <div
              className={[
                "mb-6 flex w-full flex-wrap items-center gap-4 print:hidden rounded-[28px] px-6 py-4",
                highlightLocalhostHeader
                  ? "border border-amber-300/80 bg-gradient-to-r from-amber-100 via-amber-200 to-amber-100 shadow-[0_20px_50px_rgba(15,23,42,0.12)] dark:border-amber-500/50 dark:from-amber-900/60 dark:via-amber-800/60 dark:to-amber-900/60 dark:shadow-[0_25px_55px_rgba(0,0,0,0.55)]"
                  : "border border-indigo-100/60 bg-gradient-to-br from-white via-indigo-50/80 to-white shadow-[0_20px_50px_rgba(15,23,42,0.12)] dark:border-indigo-500/30 dark:bg-gradient-to-br dark:from-[#080414] dark:via-[#110b2c] dark:to-[#1b1540] dark:shadow-[0_25px_55px_rgba(0,0,0,0.55)]",
              ].join(" ")}
            >
              {title && (
                <h1
                  className={[
                    "text-3xl font-bold",
                    highlightLocalhostHeader
                      ? "text-amber-900 drop-shadow-[0_6px_18px_rgba(180,83,9,0.25)] dark:text-amber-100"
                      : "text-indigo-900 drop-shadow-[0_6px_18px_rgba(79,70,229,0.25)] dark:text-indigo-100",
                    titleClassName,
                  ].join(" ")}
                >
                  {title}
                </h1>
              )}
              <div className="ml-auto">
                {(headerRight || (buttonLabel && onButtonClick)) && (
                  <div className="flex items-center gap-3">
                    {headerRight}
                    {buttonLabel && onButtonClick && (
                      <button onClick={onButtonClick} className={buttonClassName}>
                        {buttonLabel}
                      </button>
                    )}
                  </div>
                )}
                {highlightLocalhostHeader && (
                  <div className="flex items-center justify-end">
                    <div className="inline-flex items-center gap-2 rounded-full border border-amber-300/70 bg-amber-100/70 px-3 py-1 text-xs font-semibold text-amber-900 shadow-sm dark:border-amber-500/40 dark:bg-amber-900/30 dark:text-amber-100">
                      <span aria-hidden>⚠️</span>
                      <span>Localhost Admin Portal — for testing only</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="w-full">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default PageTemplate;
